import { LineItem } from 'shared/types/cart';
import { Money } from 'shared/types/product';
import { CurrencyHelpers } from './currencyHelpers';

export class CartHelpers {
  static readonly calculateTotalQuantity = (lineItems: LineItem[] | undefined): number => {
    if (lineItems) {
      return lineItems?.reduce((currentQuantity: number, item: any) => {
        // dont include warranty items to total count
        if (!item.lineGroupId) {
          return currentQuantity + (item.count || 0);
        }
        return currentQuantity;
      }, 0);
    }
    return 0;
  };

  static readonly calculateTotalPrice = (amount: Money | undefined, quantity: number | undefined) => {
    const amountInCents = (amount?.centAmount ?? 0) * (quantity ?? 0);
    const totalAmount = CurrencyHelpers.formatForCurrency({
      fractionDigits: amount?.fractionDigits,
      centAmount: amountInCents,
      currencyCode: amount?.currencyCode,
    });
    return totalAmount;
  };

  static readonly calculateShippingAmount = (
    shippingAmount: Money | undefined,
    shippingDiscount: Money | undefined,
    currentAdjustment: any,
  ): Money => {
    let amountInCents = shippingAmount?.centAmount;

    if (shippingDiscount && !currentAdjustment) {
      amountInCents = (shippingAmount?.centAmount ?? 0) - (shippingDiscount?.centAmount ?? 0);
    } else if (currentAdjustment) {
      amountInCents = (currentAdjustment?.selectedMethodAmount ?? 0) - (currentAdjustment?.discountedAmount ?? 0);
    }

    const totalAmount = {
      fractionDigits: shippingAmount?.fractionDigits,
      centAmount: amountInCents,
      currencyCode: shippingAmount?.currencyCode,
    };
    return totalAmount;
  };

  static readonly calculateTotalLineDiscount = (
    orderDiscountShare: Money | undefined,
    itemLevelDiscount: Money | undefined,
  ): Money => {
    const amountInCents = (orderDiscountShare?.centAmount ?? 0) + (itemLevelDiscount?.centAmount ?? 0);
    const totalAmount = {
      fractionDigits: orderDiscountShare?.fractionDigits ?? itemLevelDiscount?.fractionDigits,
      centAmount: amountInCents,
      currencyCode: orderDiscountShare?.currencyCode ?? itemLevelDiscount?.currencyCode,
    };
    return totalAmount;
  };

  static readonly calculateItemCounts = (lineItems: LineItem[] | undefined): Record<string, number> => {
    return (
      lineItems?.reduce<Record<string, number>>((accumulator, item) => {
        const sku = item?.variant?.sku;
        const count = item?.count;
        if (sku && count) {
          accumulator[sku] = (accumulator[sku] || 0) + count;
        }
        return accumulator;
      }, {}) || {}
    );
  };
}
